<template>
    <div>
        This is the sell page
    </div>
</template>